import { Link } from "@tanstack/react-router";
import ViewDetailButton from "../viewDetailButton";
import Card from "./card";

const RealAssetCard = ({
  title,
  descriptionMetaData,
  description,
  detailUrl,
}: { title: string; descriptionMetaData?: string; description?: string; detailUrl: string }) => {
  return (
    <Card>
      <Link to={detailUrl} className={"mb-4 text-2xl text-blue-200"}>{title}</Link>
      {descriptionMetaData && (
        <p className="my-[0.75rem] text-blue-400">{descriptionMetaData}</p>
      )}
      {description && (
        <p className="my-[0.75rem] text-blue-400">{description}</p>
      )}
      <div className="flex w-full justify-end">
        <ViewDetailButton detailUrl={detailUrl} />
      </div>
    </Card>
  );
};

export default RealAssetCard;
